/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Form,
  Panel,
  Button,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Select from 'loracoms/Select';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import { parseContent } from '../util';
import Upload from './Upload';
import styles from '../styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
  network: PropTypes.string.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  typesJSON: PropTypes.object.isRequired,
  networkDetail: PropTypes.object.isRequired,
};

class Netork extends React.Component {
  constructor(props) {
    super(props);
    const { options, types } = parseContent(props.typesJSON);
    this.state = {
      options,
      selected: props.network,
    };
    this.network = props.network;
    this.types = types;
    this.networkDetail = props.networkDetail;
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.net');
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeNetwork = this.onChangeNetwork.bind(this);
  }

  componentWillReceiveProps({ network, networkDetail, typesJSON }) {
    if (network !== this.props.network) {
      this.setState({ selected: network });
      this.network = network;
    }
    if (!_.isEqual(networkDetail, this.props.networkDetail)) {
      this.networkDetail = networkDetail;
    }
    if (!_.isEqual(typesJSON, this.props.typesJSON)) {
      const { options, types } = parseContent(typesJSON);
      this.types = types;
      this.setState({ options });
    }
  }

  onChangeNetwork(selected) {
    this.setState({ selected });
  }

  onSubmit() {
    const { selected } = this.state;
    const network = _.find(this.types.networktypes,
       n => n.networks && n.networks.name === selected);
    if (!selected) return;
    const body = network.networks;

    // add network or update network
    const method = this.networkDetail.data ? 'PUT' : 'POST';

    callAPI({
      body,
      method,
      endpoint: '/tdmng/networks',
    }).then(() => {
      this.network = selected;
      this.props.onSubmitted(selected);
    }).catch(() => {
      this.setState({ selected: this.network });
    });
  }

  render() {
    const {
      options,
      selected,
      showModal = false,
    } = this.state;
    return (
      <Panel bsStyle="aisz-white" className={styles.net}>
        <Form>
          <FormGroup>
            <Col sm={2}>
              <ControlLabel>
                {this.intlMsg.msg('label')}
              </ControlLabel>
            </Col>
            <Col sm={6}>
              <Select
                value={selected}
                onChange={this.onChangeNetwork}
                options={options}
              />
            </Col>
            <Col md={4} className={styles.clearRight}>
              <Button
                bsStyle="aisz-primary"
                onClick={() => this.setState({ showModal: true })}
                className={styles.addBtn}
              >
                <span className="glyphicons glyphicons-upload" aria-hidden="true" />&nbsp;
                {this.intlMsg.msg('upload')}
              </Button>
              <Button
                bsStyle="aisz-success"
                onClick={this.onSubmit}
                className={styles.addBtn}
              >
                <span className="glyphicons glyphicons-refresh" aria-hidden="true" />&nbsp;
                {this.intlMsg.msg('update')}
              </Button>
            </Col>
          </FormGroup>
        </Form>
        <Upload
          show={showModal}
          onHide={() => this.setState({ showModal: false })}
        />
      </Panel>
    );
  }
}

Netork.propTypes = propTypes;

const mapStateToProps = state => ({
  typesJSON: state.tdm.setting,
  networkDetail: state.tdm.getNetwork,
});

export default connect(mapStateToProps)(injectIntl(Netork));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Network/index.jsx